var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDjLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 44,
    viewBox: "0 0 152 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_167_518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0743447 12.5722V0.024808C0.191295 0.0177201 0.304702 0.00708822 0.418109 0.00708822C6.89292 0.00708822 13.3695 -0.0141755 19.8461 0.0177201C23.2873 0.0336679 26.6664 0.485522 29.9003 1.70819C35.3438 3.76545 38.7549 7.64432 40.3957 13.0878C41.3597 16.2863 41.6042 19.568 41.5635 22.8869C41.5493 24.1911 41.5369 25.5076 41.6999 26.7976C42.0259 29.3617 43.7448 30.9706 46.3478 31.3126C47.6289 31.481 48.9048 31.4774 50.1717 31.1851C52.4133 30.6659 53.7228 29.2607 54.148 27.0634C54.2739 26.4149 54.3217 25.7415 54.3235 25.0806C54.3394 21.0422 54.3323 17.0021 54.3323 12.962V12.5704H53.8433C50.5403 12.5704 47.2356 12.5669 43.9326 12.5775C43.7625 12.5775 43.5835 12.5722 43.5835 12.5722V12.5686C43.4488 12.2355 43.3301 11.8971 43.2167 11.5551C42.1517 8.30881 40.4631 5.41871 37.9238 3.023C36.6905 1.86058 35.3172 0.889534 33.7473 0.0354399H67.1225C67.126 0.132899 67.1367 0.242761 67.1367 0.356168C67.1367 8.80673 67.149 17.2591 67.1278 25.7114C67.1207 28.5749 66.7255 31.3888 65.6872 34.084C63.9471 38.6114 60.653 41.5104 55.9785 42.928C52.8173 43.8866 49.5693 44.0957 46.2875 43.9575C43.9521 43.8582 41.6521 43.5304 39.4353 42.7809C34.107 40.9788 30.8394 37.2824 29.2783 32.0409C28.4721 29.3351 28.3675 26.5744 28.667 23.7853C28.8655 21.9371 28.8017 20.1031 28.2896 18.301C27.4815 15.4446 25.5767 13.6992 22.6759 12.9656C21.4231 12.6484 20.1455 12.5704 18.8591 12.5704C12.7617 12.5669 6.66788 12.5704 0.570499 12.5704H0.0708008L0.0743447 12.5669V12.5722Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.7245H12.7742V30.96C12.7742 31.2736 12.9337 31.4296 13.2562 31.4296C15.0849 31.4296 16.9153 31.426 18.7458 31.4296C21.1379 31.4331 23.4663 31.1744 25.5484 29.7586C26.2519 34.3285 28.015 38.3562 31.4721 41.645C30.7775 41.925 30.1449 42.2068 29.4928 42.4371C26.95 43.3408 24.3133 43.8423 21.6181 43.9043C17.7233 43.9965 13.825 43.9752 9.9284 43.9911C6.76719 44.0018 3.60598 43.9947 0.446539 43.9947H0V15.7245Z",
    fill: "#ED2938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.19 0.474892V4.40514H126.82V11.6773H134.19V15.8433C134.321 20.3104 132.172 22.3943 127.744 22.093H119.903L119.922 22.0735L119.883 22.093C117.603 21.8184 116.516 20.4415 116.621 17.9661V3.9143H120.434V18.0848H127.903C128.899 17.9661 129.462 17.5089 129.594 16.7098V15.884C129.581 15.7919 129.567 15.7015 129.555 15.6094H122.479V5.42757C122.387 2.16536 123.672 0.513875 126.331 0.474892H134.194H134.19ZM120.156 28.1869H124.283V24.0599H120.156V28.1869ZM126.053 28.1869H130.18V24.0599H126.053V28.1869Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.299 0.0230379C141.538 -0.108089 143.688 0.324274 145.745 1.32013C148.011 2.67037 149.558 4.39274 150.384 6.48899C151.21 8.58524 151.57 10.5769 151.465 12.4641V16.1977H136.352V12.4641H147.26V11.6773C147.102 6.76364 144.45 4.22794 139.3 4.07201V0.0230379H139.299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.11 5.55692V18.1752H84.6297C86.9174 18.1486 87.9876 17.4912 87.8441 16.203H85.0249V12.457H94.5085V16.203H92.3786C91.8523 19.9224 89.8092 21.8946 86.2476 22.1178H79.3865C76.468 22.1568 74.9299 20.7375 74.7722 17.8598V5.55692H79.11ZM78.7361 24.09H82.8772V28.2312H78.7361V24.09ZM84.651 24.09H88.7921V28.2312H84.651V24.09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9474 0.607788H103.204C107.068 0.792074 109.349 2.63139 110.045 6.1275V16.203H93.4648V12.457H105.234V7.17297C105.326 5.74121 104.55 4.80738 102.908 4.37324H95.9474V0.607788ZM99.6544 22.4138H103.795V18.2726H99.6544V22.4138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.483 32.0338H74.7722V44H151.483V32.0338Z",
    fill: "#ED2938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8423 35.677V39.9014C81.8086 41.7797 80.9918 42.6834 79.3899 42.6125V41.3261C80.0827 41.3225 80.4283 40.8406 80.4247 39.8819V35.677H81.8441H81.8423ZM80.4867 33.4071H81.8104V34.7308H80.4867V33.4071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6988 35.677V39.9014C84.6651 41.7797 83.8482 42.6834 82.2463 42.6125V41.3261C82.9392 41.3225 83.2847 40.8405 83.2812 39.8819V35.677H84.7005H84.6988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4974 35.677V39.524H90.0963V40.7218H89.4974C89.5098 41.2605 89.3964 41.6964 89.1571 42.0331C88.7833 42.4584 88.2322 42.6515 87.5057 42.6125H85.6575V41.3332H87.6811C88.0585 41.2995 88.2038 41.0957 88.117 40.7218C87.0822 40.7768 86.3255 40.4525 85.8435 39.7508C85.3616 39.0491 85.2818 38.1985 85.6043 37.2009C85.9251 36.2033 87.0573 35.6947 88.9994 35.6788H89.4974V35.677ZM88.1152 36.9192C87.0308 36.9652 86.5754 37.5216 86.7472 38.5901C86.9776 39.2918 87.4348 39.6037 88.1152 39.524V36.9192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.925 39.5222V40.7201H89.8252V39.5222H91.925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8227 39.5222V40.7201H91.7229V39.5222H93.8227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7204 39.5222V40.7201H93.6206V39.5222H95.7204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6184 39.5222V40.7201H95.5186V39.5222H97.6184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5161 39.5222V40.7201H97.4163V39.5222H99.5161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.414 39.5222V40.7201H99.314V39.5222H101.414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.312 39.5222V40.7201H101.212V39.5222H103.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.209 39.5222V40.7201H103.11V39.5222H105.209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.107 39.5222V40.7201H105.007V39.5222H107.107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.005 39.5222V40.7201H106.905V39.5222H109.005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.903 39.5222V40.7201H108.803V39.5222H110.903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.8 39.5222V40.7201H110.701V39.5222H112.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.415 35.677H115.891V40.7218H112.6V39.524H114.417V35.677H114.415ZM112.668 33.4071H113.991V34.7308H112.668V33.4071ZM114.56 33.4071H115.884V34.7308H114.56V33.4071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.801 35.677V39.524H121.4V40.7218H120.801C120.813 41.2605 120.7 41.6964 120.461 42.0331C120.087 42.4584 119.536 42.6515 118.809 42.6125H116.961V41.3332H118.985C119.362 41.2995 119.508 41.0957 119.421 40.7218C118.386 40.7768 117.629 40.4525 117.147 39.7508C116.665 39.0491 116.586 38.1985 116.908 37.2009C117.229 36.2033 118.361 35.6947 120.303 35.6788H120.801V35.677ZM119.421 36.9192C118.336 36.9652 117.881 37.5216 118.053 38.5901C118.283 39.2918 118.74 39.6037 119.421 39.524V36.9192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.229 39.5222V40.7201H121.129V39.5222H123.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.126 39.5222V40.7201H123.027V39.5222H125.126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.024 39.5222V40.7201H124.924V39.5222H127.024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.922 39.5222V40.7201H126.822V39.5222H128.922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.82 39.5222V40.7201H128.72V39.5222H130.82Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.717 39.5222V40.7201H130.618V39.5222H132.717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.615 39.5222V40.7201H132.516V39.5222H134.615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.513 39.5222V40.7201H134.413V39.5222H136.513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.411 39.5222V40.7201H136.311V39.5222H138.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.309 39.5222V40.7201H138.209V39.5222H140.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.206 39.5222V40.7201H140.107V39.5222H142.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.106 39.5222V40.7201H142.006V39.5222H144.106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.39 37.8512C144.436 36.439 145.228 35.7142 146.766 35.6752H148.159V39.4336C148.205 41.1613 147.358 41.9888 145.618 41.9179H144.388V40.7201H143.922V39.5222H144.388V37.8512H144.39ZM146.349 36.9617C146.059 36.983 145.899 37.1495 145.871 37.4596V40.6368H146.192C146.523 40.6208 146.679 40.4436 146.658 40.1069V36.9599H146.349V36.9617Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_167_518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 151.483,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjLogo);
export default __webpack_public_path__ + "static/media/djLogo.10c35e214f3378eaabbb540e213d74df.svg";
export { ForwardRef as ReactComponent };